import { render, staticRenderFns } from "./detailTemplate.vue?vue&type=template&id=f0df4aa6"
import script from "./detailTemplate.vue?vue&type=script&lang=js"
export * from "./detailTemplate.vue?vue&type=script&lang=js"
import style0 from "./detailTemplate.vue?vue&type=style&index=0&id=f0df4aa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports